module.exports = __webpack_public_path__ + "ba.f27ae1ea.svg";